<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Retire / Merge ID Summary
          </div>
        </template>
      </es-header>
    </div>
    <div>
      <es-form style="margin: 0rem 1rem; padding: 0">
        <template #es-form>
          <table role="presentation" style="width: 100%">
            <tbody>
              <tr>
                <td role="rowheader" class="property has-text-grey">
                  ID to Retire
                </td>
                <td>
                  <div
                    class="content has-text-right is-pulled-right"
                    style="font-size: 16px; font-weight: 700; color: #000000"
                  >
                    {{ retireId ? formatStateID(retireId) : 'None Selected' }}
                  </div>
                </td>
              </tr>
              <tr>
                <td role="rowheader" class="property has-text-grey">
                  ID to Merge to
                </td>
                <td>
                  <div
                    class="content has-text-right is-pulled-right"
                    style="color: #000000"
                  >
                    {{ mergeId ? formatStateID(mergeId) : 'None Selected' }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import StateIdUtils from '@/mixins/StateIdUtils';

export default {
  mixins: [
    StateIdUtils,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  props: {
    mergeId: {
      type: String,
    },
    retireId: {
      type: String,
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    vertical-align: middle
    padding: 0.5rem 0.25rem
  table tr
    border-bottom: 1px solid #eee
    &:last-child
      border: 0
  .document
    width: 100%
  .property
    font-size: 12px
  .has-text-right
    padding-right: 0
</style>
